// Product card image carousel: dots (plus, on mobile, two arrow buttons
// flanking them) let a shopper browse a product's other photos (e.g. the
// individual books in a pack) from the collection grid without opening the
// product page. Stays on the first image unless the shopper explicitly
// interacts with the carousel or swipes the track.

function isRTLTrack(track) {
  return getComputedStyle(track).direction === 'rtl';
}

// Chrome/Firefox use the "negative" RTL scrolling convention: in a
// right-to-left track (this site is Arabic), scrollLeft: 0 sits at the start
// (right edge) and moving into the content takes negative values, not
// positive ones - a plain positive offset just gets clamped back to 0.
function scrollTrackToIndex(track, index) {
  const offset = track.clientWidth * index;
  track.scrollTo({ left: isRTLTrack(track) ? -offset : offset, behavior: 'smooth' });
}

function currentTrackIndex(track) {
  return Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
}

// The quick-add popup shows on hover/tap same as the carousel controls, so
// it's the expected first thing a shopper sees when they land on the image -
// but once they're clearly browsing photos, the popup sitting on top of the
// image fights for the same space. Hide it for the rest of this hover pass;
// it comes back next time the pointer leaves and re-enters the card.
function hideQuickAddWhileBrowsing(triggerEl) {
  const cardWrapper = triggerEl.closest('.card-wrapper');
  if (!cardWrapper || cardWrapper.classList.contains('card-wrapper--carousel-active')) return;
  cardWrapper.classList.add('card-wrapper--carousel-active');
  cardWrapper.addEventListener(
    'mouseleave',
    () => cardWrapper.classList.remove('card-wrapper--carousel-active'),
    { once: true }
  );
}

document.addEventListener('click', (event) => {
  const dot = event.target.closest('[data-carousel-dot]');
  const arrow = event.target.closest('[data-carousel-prev], [data-carousel-next]');
  const control = dot || arrow;
  if (!control) return;

  event.preventDefault();
  event.stopPropagation();

  // Controls live next to (not inside) the media block they act on, so the
  // nearest shared ancestor is the card's own inner wrapper.
  const card = control.closest('.card__inner');
  const track = card?.querySelector('[data-carousel-track]');
  if (!track) return;

  const dots = card.querySelectorAll('[data-carousel-dot]');
  let index;
  if (dot) {
    index = Number(dot.dataset.index) || 0;
  } else {
    const delta = arrow.hasAttribute('data-carousel-prev') ? -1 : 1;
    index = Math.min(dots.length - 1, Math.max(0, currentTrackIndex(track) + delta));
  }

  scrollTrackToIndex(track, index);

  // Set the active dot immediately rather than waiting on the 'scroll'
  // listener below - keeps the UI in sync with the click even if a scroll
  // event never fires (e.g. the click re-targets the slide it's already on,
  // so scrollTo is a no-op and no 'scroll' event follows).
  dots.forEach((d, i) => d.classList.toggle('is-active', i === index));

  hideQuickAddWhileBrowsing(control);
});

function syncDotsToScroll(track) {
  const card = track.closest('.card__inner');
  const dots = card?.querySelectorAll('[data-carousel-dot]');
  if (!dots || !dots.length) return;

  let ticking = false;
  track.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const index = currentTrackIndex(track);
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
        ticking = false;
      });
    },
    { passive: true }
  );
}

function initCardCarousels(root = document) {
  root.querySelectorAll('[data-carousel-track]').forEach(syncDotsToScroll);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initCardCarousels());
} else {
  initCardCarousels();
}

// Predictive search, quick-add, and filtered collection results swap in
// fresh product cards after the initial load; re-scan when that happens.
document.addEventListener('shopify:section:load', () => initCardCarousels());
